import { render, staticRenderFns } from "./NewRecipesPage.vue?vue&type=template&id=0c0773a7&"
import script from "./NewRecipesPage.vue?vue&type=script&lang=js&"
export * from "./NewRecipesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports